// src/services/api.js
import axios from 'axios';

const API_BASE_URL = 'http://localhost:11434/api'; // Ollama API的本地地址

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const generateText = async (prompt) => {
  try {
    const response = await api.post('/generate', {
      model: 'deepseek-r1:1.5b', // 使用DeepSeek R1模型
      prompt: prompt,
      stream: false, // 设置为false以获取完整响应
    });
    return response.data;
  } catch (error) {
    console.error('Error generating text:', error);
    throw error;
  }
};

// src/services/api.js
export const generateTextStream = async (prompt, onDataReceived) => {
    try {
      const response = await fetch('http://localhost:11434/api/generate', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          model: 'deepseek-r1:1.5b', // 使用DeepSeek R1模型
          prompt: prompt,
          stream: true, // 启用流式响应
        }),
      });
  
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
  
      const reader = response.body.getReader();
      const decoder = new TextDecoder();
      let flag = true;
      while (flag) {
        const { done, value } = await reader.read();
        if (done) {
            flag = false;
            break;
        }
  
        const chunk = decoder.decode(value, { stream: true });
        const parsedChunk = JSON.parse(chunk); // 解析每个分块
        onDataReceived(parsedChunk.response); // 调用回调函数处理数据
      }
    } catch (error) {
      console.error('Error generating text:', error);
      throw error;
    }
  };